module.exports = __webpack_public_path__ + "img/amazon-web-services.19cac6c9.svg";